import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Shield, ArrowLeft, LogOut } from 'lucide-react';
import { authService } from '../services/authService';

export const Unauthorized: React.FC = () => {
  const navigate = useNavigate();
  const currentUser = authService.getCurrentUser();

  const handleLogout = async () => {
    await authService.logout();
    navigate('/login');
  };

  const handleGoBack = () => {
    if (currentUser) {
      switch (currentUser.role) {
        case 'ADMIN':
        case 'OPERATOR':
          navigate('/crm');
          break;
        case 'CLIENT':
          navigate('/client/applications');
          break;
        default:
          navigate('/');
      }
    } else {
      navigate('/login');
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-red-500 via-red-600 to-pink-700 flex items-center justify-center p-4">
      <div className="max-w-md w-full">
        <div className="bg-white rounded-2xl shadow-2xl p-8 text-center">
          {/* Icon */}
          <div className="inline-flex items-center justify-center w-20 h-20 bg-red-100 rounded-full mb-6">
            <Shield className="w-10 h-10 text-red-600" />
          </div>

          {/* Title */}
          <h1 className="text-3xl font-bold text-gray-900 mb-4">Brak dostępu</h1>

          {/* Message */}
          <p className="text-gray-600 mb-2">
            Nie masz uprawnień do wyświetlenia tej strony.
          </p>

          {currentUser && (
            <div className="bg-gray-50 rounded-lg p-4 mb-6">
              <p className="text-sm text-gray-700">
                Zalogowano jako: <strong>{currentUser.username}</strong>
              </p>
              <p className="text-sm text-gray-600">
                Rola: <span className="font-medium">{currentUser.role}</span>
              </p>
            </div>
          )}

          {/* Actions */}
          <div className="space-y-3">
            <button
              onClick={handleGoBack}
              className="w-full bg-gradient-to-r from-blue-600 to-indigo-600 text-white py-3 rounded-lg font-medium hover:from-blue-700 hover:to-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition flex items-center justify-center shadow-lg"
            >
              <ArrowLeft className="mr-2" size={20} />
              Wróć do panelu głównego
            </button>

            <button
              onClick={handleLogout}
              className="w-full bg-gray-200 text-gray-700 py-3 rounded-lg font-medium hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-400 transition flex items-center justify-center"
            >
              <LogOut className="mr-2" size={20} />
              Wyloguj się
            </button>
          </div>

          {/* Support Info */}
          <div className="mt-6 pt-6 border-t border-gray-200">
            <p className="text-xs text-gray-500">
              Jeśli uważasz, że to błąd, skontaktuj się z administratorem systemu.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
